module.exports = __webpack_public_path__ + "media/dorobek/assets/images/icons/Second_criterium-040f771ed67d419f46b5493cffcf4f7f.svg";